export const OfferProductVariantDtoDescriptions = {
  uuid: "Server-generated. Read-only. Internal identifier.",
  id: "Shopify product variant ID from the store's catalog.",
  title: "Variant display name (e.g., 'Large / Blue').",
  price: "Current selling price of this variant.",
  compareAtPrice:
    "Original price before any sale. Null if the variant is not on sale.",
  inclusionType:
    "Whether this variant is explicitly included in or excluded from the offer.",
} as const;

export const OfferProductDtoDescriptions = {
  id: "Shopify product ID from the store's catalog.",
  title: "Product display name.",
  image: "URL to the product's primary image.",
  variants:
    "Specific variants of this product with their inclusion/exclusion status.",
  variationId: "References the parent variation.",
  offerId: "References the parent offer.",
} as const;
